import {useEffect, useState} from 'react';
import axiosClient from '../services/axiosClient';
import useAuthStore from '../store/useAuthStore';

let requestInterceptor = null;
let responseInterceptor = null;

const axiosIntercepters = axiosClient.interceptors;

const setInterceptors = ({token, updateAuthDetails}) => {
  responseInterceptor = axiosIntercepters.response.use(
    function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return response;
    },
    function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      const {response: {status = null} = {}} = error;

      if (status === 401) {
        // logout
        updateAuthDetails({});
      }

      return Promise.reject(error);
    },
  );

  requestInterceptor = axiosIntercepters.request.use(
    (config) => ({
      ...config,
      headers: {
        ...config.headers,
        ...(token ? {Authorization: `Bearer ${token}`} : {}),
      },
    }),
    (error) => Promise.reject(error),
  );
};

const ejectIntercepters = () => {
  if (requestInterceptor) axiosIntercepters.request.eject(requestInterceptor);
  if (responseInterceptor) axiosIntercepters.request.eject(requestInterceptor);
};

const AxiosIntercepters = () => {
  const token = useAuthStore((state) => state.token);
  const updateAuthDetails = useAuthStore((state) => state.updateAuthDetails);
  const [renderedFirstTime, setRenderedFirstTime] = useState(false);

  useEffect(() => {
    return () => ejectIntercepters();
  }, []);

  if (!renderedFirstTime) {
    setInterceptors({token, updateAuthDetails});
    if (token) setRenderedFirstTime(true);
  }

  return null;
};

export default AxiosIntercepters;
